import * as React from "react";
import type { SVGProps } from "react";
const SvgPaperPlaneTilt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "#746A80"}
    viewBox="0 0 15 15"
    {...props}
  >
    <path d="M14.207.793a1 1 0 0 0-.978-.255h-.01L1.223 4.178a1 1 0 0 0-.156 1.862l5.308 2.585 2.581 5.305a.99.99 0 0 0 .989.566.99.99 0 0 0 .875-.719l3.637-11.996v-.01a1 1 0 0 0-.25-.978M9.864 13.49l-.003.008v-.004L7.357 8.351l3-3a.5.5 0 0 0-.706-.706l-3 3L1.505 5.14h-.004.008L13.5 1.5z" />
  </svg>
);
export default SvgPaperPlaneTilt;
